import type { LucideIcon } from 'lucide-react';
import { SlidingIndicator } from '../ui/SlidingIndicator';
import styles from './ToggleTabs.module.css';

export interface ToggleTabsProps<T extends string> {
  label: string;
  options: readonly { value: T; label: string; icon?: LucideIcon }[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  /** Full width with equal options, stacked on phones. */
  block?: boolean;
  className?: string;
}

function OptionContent({ label, icon: Icon }: { label: string; icon?: LucideIcon }) {
  return <>{Icon !== undefined && <Icon size={14} aria-hidden="true" />}{label}</>;
}

export function ToggleTabs<T extends string>({ label, options, value, onChange, disabled = false, block = false, className }: ToggleTabsProps<T>) {
  return (
    <div className={className === undefined ? styles.group : `${styles.group} ${className}`} role="group" aria-label={label} data-block={block || undefined}>
      <SlidingIndicator variant="fill" labels={options.map((option) => <OptionContent key={option.value} label={option.label} icon={option.icon} />)} labelClassName={styles.option} />
      {options.map((option) => (
        <button key={option.value} type="button" className={styles.option} aria-pressed={option.value === value} disabled={disabled} onClick={() => onChange(option.value)}>
          <OptionContent label={option.label} icon={option.icon} />
        </button>
      ))}
    </div>
  );
}
